import { render, staticRenderFns } from "./ModalDocumentos.vue?vue&type=template&id=a3451a80"
import script from "./ModalDocumentos.vue?vue&type=script&lang=js"
export * from "./ModalDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentos.vue?vue&type=style&index=0&id=a3451a80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports